import { render, staticRenderFns } from "./PaymentRedirect.vue?vue&type=template&id=737c20b2&"
import script from "./PaymentRedirect.vue?vue&type=script&lang=ts&"
export * from "./PaymentRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports